export default "__VITE_ASSET__CFaFT4yU__"